export const getAnalyticsElementBlockValue = (isFromSRP?: boolean): string =>
  isFromSRP ? 'productList / SearchResults' : 'productList / Catalog';
